import * as React from 'react';
import styled from 'styled-components';
import { excludeKeys } from '../../utils';
import { ILabel } from './label-props';
import { Typography } from '../typography';
import { selectThemeSemantics } from '../../styling';

function LabelBase(props: ILabel) {
    const { children, elementRef, className, hidden } = props;
    const labelProps = excludeKeys(props, 'required', 'children', 'elementRef');
    return hidden ? null : (
        <label {...labelProps} className={className} ref={elementRef}>
            <Typography.Small>{children}</Typography.Small>
        </label>
    );
}

export const Label = styled(LabelBase).attrs({
    className: String('ap-label')
})`
    padding-right: 0.2em;
    &:after {
        content: ${({ required }) => (required ? '\'*\'' : '')};
        color: ${selectThemeSemantics(({ palette }) => palette.red)};
        margin-left: 0.5em;
    }
`;
